
import { Vue, Prop, Component, Emit, Watch } from 'vue-property-decorator'
import { InsuranceType, createInsuranceTypeList } from './insurance.interface'
import i18n from '@/lang'

@Component
export default class extends Vue {
  @Prop() open!: Function
  @Prop() data: any

  // data
  radio = 0
  title = i18n.t('Perhatian!')
  page = 0

  InsuranceType = InsuranceType
  insurance = null
  totalLoan = 0
  fee = 0
  //   details: any = this.data
  warning = ''

  insuranceVal = createInsuranceTypeList()

  tableData = [
    {
      premi: i18n.t('1 tahun'),
      nominal: '0.8%'
    },
    {
      premi: i18n.t('Total'),
      nominal: 0
    }
  ]

  @Emit('close')
  onClose() {
    this.page = 0
    this.radio = 0
    this.insurance = null
    this.warning = ''
  }

  @Emit('closeAndOpen')
  onCloseAndOpen(e: number | null) {
    return e
  }

  @Watch('insurance')
  onInsuranceSelected() {
    // console.log(this.insurance)
    this.calcPremi()
    this.calcLoan()
  }

  onInsuranceChange(value: InsuranceType) {
    if (!value) {
      this.fee = 0
      this.totalLoan = 0
    } else {
      this.onInsuranceSelected()
    }
    // if (value === InsuranceType.SIMAS) {
    //   this.warning = 'Dalam pengembangan'
    // } else {
    //   this.warning = ''
    // }
  }

  calcPremi() {
    if (!this.insurance) {
      this.fee = 0;
      return ;
    }
    const calculated = () => Math.ceil(0.008 * this.data.contractAmount)

    if (this.insurance === InsuranceType.INTRA_ASIA) {
      this.fee= calculated() >= 10000 ? calculated() : 10000
    } else {
      this.fee = calculated()
    }
  }

  calcLoan() {
    if (!this.insurance) {
      this.totalLoan = 0;
      return ;
    }
    this.totalLoan = this.fee + this.data.contractAmount
  }

  changePage(arg: string) {
    if (this.radio === 1 && arg === 'radio') {
      this.page = 1
    } else if (this.page === 1 && arg === 'insurance') {
      this.onCloseAndOpen(this.insurance)
      this.page = 0
      this.radio = 0
    } else if (this.radio === 2) {
      this.insurance = null
      this.onCloseAndOpen(this.insurance)
    }
  }
}
